<template>
    <dialog-window
        v-bind="dialogProps"
        :show="show"
        :defaultFocusId="defaultId"
        :closeOnEscape="true"
        :icon="icon"
        :color="color"
        @closed="onCancel"
        style="z-index: 1007;"
    >
        <template v-if="header" v-slot:header>{{ header }}</template>
        <template v-if="type === 'confirm'" v-slot:body>
            <component
                v-bind="bodyComponentProps"
                :is="componentName"
                v-if="componentName"
                @closed="onOk"
            ></component>
            <div v-else v-html="body" class="info-label"></div>
            <div v-if="typeToConfirm" class="info-label">
                <br>
                If you still want to proceed, type "{{ typeToConfirm }}" in the box below.<br>
                <input type="text" v-model="confirmText" class="confirm-input">
            </div>
        </template>
        <template v-slot:footer>
            <button class="button icon" ref="cancel" :id="critical ? defaultId : ''" @click="onCancel">
                <i v-show="cancelIcon" :class="cancelIcon"></i>
                {{ cancelText }}
            </button>
            <button
                class="button icon"
                :class="{ danger: critical, primary: !critical }"
                ref="ok"
                :id="critical ? '' : defaultId"
                :style="okStyles"
                @click="onOk"
                :disabled="!!typeToConfirm && typeToConfirm !== confirmText"
            >
                <i v-show="okIcon" :class="okIcon"></i>
                {{ okText }}
            </button>
        </template>
    </dialog-window>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { strings } from '../../utils';

    export default {
        name: 'DialogConfirm',
        data() {
            return {
                defaultId: strings.random(),
                confirmText: '',
            };
        },
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                header: 'dialog/header',
                headerIcon: 'dialog/headerIcon',
                okText: 'dialog/okText',
                okIcon: 'dialog/okIcon',
                okStyles: 'dialog/okStyles',
                cancelText: 'dialog/cancelText',
                cancelIcon: 'dialog/cancelIcon',
                critical: 'dialog/critical',
                variables: 'layout/variables',
                componentName: 'dialog/componentName',
                bodyComponentProps: 'dialog/bodyComponentProps',
                dialogProps: 'dialog/dialogProps',
                body: 'dialog/body',
                ok: 'dialog/ok',
                cancel: 'dialog/cancel',
                type: 'dialog/type',
                typeToConfirm: 'dialog/typeToConfirm',
            }),
            icon() {
                if (this.headerIcon) return this.headerIcon;
                return this.critical
                    ? 'far fa-exclamation-triangle'
                    : 'far fa-question';
            },
            color() {
                return this.critical
                    ? this.variables.colorError
                    : this.variables.colorMain;
            },
        },
        methods: {
            onCancel() {
                this.cancel();
                this.$store.dispatch('dialog/clear');
                this.confirmText = '';
            },
            onOk() {
                this.ok();
                this.$store.dispatch('dialog/clear');
                this.confirmText = '';
            }
        }
    };
</script>

<style lang="scss" scoped>
    .confirm-input {
        margin-top: 0.5em;
        width: 100%;
    }
</style>